import { Theme } from "@amx/ux-twoui-theming";
import { Depths, IStackStyles } from "@fluentui/react";
import { listItemPadding } from "../../ListItems/shared/styles";

export const linkListFooterContainerStyle = (theme: Theme, borderRadius: boolean, shadow: boolean): IStackStyles => {
    return {
        root: {
            boxShadow: shadow ? Depths.depth8 : undefined,
            borderRadius: borderRadius ? "0 0 4px 4px" : "0px",
            padding: listItemPadding,
            backgroundColor: theme.palette.neutralMed
        }
    };
};

export const linkListFooterLabelContainerStyle = (): IStackStyles => {
    return {
        root: {
            margin: "0 16px 0 0"
        }
    };
};
